// Module
var code = "<p class=\"note\"><strong>NOTE:</strong> To see if any of these plans are viable options, check out the <a href=\"/changeRepaymentPlan\" target=\"_blank\"> Manage Repayment tool </a> in Account Access to get estimated monthly payment amounts.</p> ";
// Exports
export default code;